import React, { useEffect, useState } from "react";

function CategoryModal({
  mode,
  category,
  isNameTaken,
  onSave,
  onClose,
  saving,
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [visible, setVisible] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setName(category?.categoryName || "");
    setDescription(category?.description || "");
    setVisible(category?.visible ?? true);
    setError("");
  }, [category]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const trimmedName = name.trim();
    const trimmedDescription = description.trim();
    if (!trimmedName) {
      setError("Name is required.");
      return;
    }
    if (!trimmedDescription) {
      setError("Description is required.");
      return;
    }

    if (isNameTaken(trimmedName, category?.categoryId || "")) {
      setError("Category names must be unique.");
      return;
    }

    onSave({
      name: trimmedName,
      description: trimmedDescription,
      visible,
    });
  };

  return (
    <div className="cs-modal-overlay" onClick={saving ? undefined : onClose}>
      <form
        className="category-settings-modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={handleSubmit}
      >
        <div className="category-settings-modal-title">
          {mode === "edit" ? "Edit Category" : "Add Category"}
        </div>

        <label className="category-settings-field">
          <span>Category Name</span>
          <input
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (error) setError("");
            }}
            placeholder="Type category name"
            autoFocus
          />
        </label>

        <label className="category-settings-field">
          <span>Description</span>
          <textarea
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
              if (error) setError("");
            }}
            placeholder="Type category description"
          />
        </label>

        <label className="category-settings-modal-checkbox">
          <input
            type="checkbox"
            checked={visible}
            onChange={(e) => setVisible(e.target.checked)}
          />
          <span>Display to Users</span>
        </label>

        {error ? <div className="category-settings-error">{error}</div> : null}

        <div className="category-settings-modal-actions">
          <button className="cs-btn cs-btn-blue" type="submit" disabled={saving}>
            {saving ? "Saving..." : "Save"}
          </button>
          <button
            className="cs-btn cs-btn-outline"
            type="button"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default CategoryModal;
